import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCrunchbaseComponent } from './simple-icons-crunchbase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCrunchbaseComponent ],
    exports:      [ SimpleIconsCrunchbaseComponent ],
    bootstrap:    []
})
export class SimpleIconsCrunchbaseModule {}
